import client from './client'

const apiBasePath = '/api/admin/mst/service/'

export default {
  list: entryForm => client.post(apiBasePath + 'list', entryForm),
  detail: entryForm => client.post(apiBasePath + 'detail', entryForm),
  delete: entryForm => client.post(apiBasePath + 'delete', entryForm),
  update: entryForm => client.post(apiBasePath + 'update', entryForm),
  register: entryForm => client.post(apiBasePath + 'register', entryForm)
}
